import { Button, Stack, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { IconButton, Icons } from 'utoniq-ui'

import { useRouter, useTranslation } from '@/core'

import { ArtistSideMenu } from './ArtistSideMenu'

export const ArtistHeaderItemsLeft: FC = () => {
  const { routerPages } = useRouter()
  const [openSideMenu, setOpenSideMenu] = useState<boolean>(false)

  return (
    <>
      <Stack spacing={2} direction="row">
        <IconButton.Menu
          onClick={() => setOpenSideMenu(true)}
          edge="start"
          color="white"
          bgcolor="transparent"
          sx={{ display: { md: 'none' } }}
        />
        <IconButton.Notice
          href={routerPages.Notifications}
          color="white"
          bgcolor="transparent"
        />
        {/**
         * @description
         * Open when function is implemented in the future
         * https://app.clickup.com/t/908127/UT-6887
         */}
        {/*<IconButton.Search href={'#'} color="white" />*/}
      </Stack>
      <ArtistSideMenu
        open={openSideMenu}
        onClose={() => setOpenSideMenu(false)}
      />
    </>
  )
}

export type ArtistHeaderItemsRightProps = {
  artistId: string
}
export const ArtistHeaderItemsRight: FC<ArtistHeaderItemsRightProps> = ({
  artistId,
}) => {
  const { t } = useTranslation('consoleHome')
  const { generatePath, routerPages } = useRouter()
  return (
    <Button
      sx={{ minWidth: 124, mr: -3, color: 'white' }}
      variant="text"
      href={generatePath(routerPages.ArtistTop, { artistId })}
    >
      <Icons.Window color="inherit" />
      <Typography sx={{ ml: 1 }} color="inherit" variant="subtitle1">
        {t('viewTheApp')}
      </Typography>
    </Button>
  )
}
